import Cookies from "js-cookie";

export const initPopup = () => {
    const message = document.querySelector('.js-popup');
    if (!message) return;

    // Automatically show popup if not previously closed
    if (!Cookies.get('popup-message')) {
        message.classList.add('active');
    }

    // Show popup when .cta-text is clicked
    const ctaText = document.querySelector('.newsletter-cta .cta-text');
    if (ctaText) {
        ctaText.addEventListener('click', () => {
            message.classList.add('active');
        });
    }

    // Add close handlers
    document.querySelectorAll('.js-popup-close').forEach((cookieClose) => {
        cookieClose.addEventListener('click', () => {
            Cookies.set('popup-message', 'set', { expires: 7 });

            message.classList.add('fade');
            setTimeout(() => message.classList.remove('active', 'fade'), 1000);
        });
    });
};
